// src/app/router/guards/DBAGuard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '@/shared/hooks/usePermission';

export function DBAGuard({ children }: { children: React.ReactNode }) {
  const hasDBA = usePermission('dba-tools');
  if (!hasDBA) return <Navigate to="/" replace />;
  return <>{children}</>;
}
